import { Box, Grid, Typography } from '@mui/material'
import React from 'react'

import ProfileCard from '../Profile/ProfileCard'
import { useNavigate } from 'react-router-dom'

export default function CandidateCoaches({ coaches }) {
    const navigate = useNavigate();
    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, mt: 10 }}>
                <Typography sx={{
                    fontFamily: "Inter",
                    fontWeight: 600,
                    fontSize: "30px",
                    lineHeight: "36px",
                    color: "#000000",
                    mb: 3
                }}>Coaches on PPLACD</Typography>
                <Typography className='text1Bold' sx={{ color: '#2544EE', cursor: 'pointer' }} onClick={() => navigate('/candidate/recommended-coach')}>View all</Typography>
            </Box>


            <Grid container spacing={2} mt={4}  >
                {coaches && coaches.length > 0
                    ?
                    coaches.slice(0,8).map((item, index) => (
                        <Grid item md={3} xs={12} mt={{ xs: 8 }}>
                            <ProfileCard coach={item}/>
                        </Grid>
                    ))
                    :
                    0
                }
            </Grid>
        </>
    )
}
